import { timeParse, timeFormat } from "d3-time-format";

const DATE_FORMAT = "%Y-%m-%d";

export function formatDate(date) {
  const formatter = timeFormat(DATE_FORMAT);
  return formatter(date);
}

export function parseDate(dateStr) {
  const parser = timeParse(DATE_FORMAT);
  return parser(dateStr);
}

export function parseYear(year) {
  return parseDate(`${year}-01-01`);
}

export function formatQuarter(dateObj) {
  let d = dateObj;
  if (typeof dateObj === "number") {
    d = new Date(dateObj);
  }
  const month = d.getMonth();
  const quarter = Math.floor(month / 3) + 1;
  return `${d.getFullYear()} Q${quarter}`;
}

export function formatYear(dateObj) {
  if (typeof dateObj === "number") {
    const d = new Date(dateObj);
    return d.getFullYear();
  }
  return dateObj.getFullYear();
}
